import { render, staticRenderFns } from "./usqManage.vue?vue&type=template&id=4ab5da75&scoped=true&"
import script from "./usqManage.ts?vue&type=script&lang=ts&"
export * from "./usqManage.ts?vue&type=script&lang=ts&"
import style0 from "./usqManage.vue?vue&type=style&index=0&id=4ab5da75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab5da75",
  null
  
)

export default component.exports